module.exports = __webpack_public_path__ + "static/media/icon2.9f554e27.png";